var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.valid
    ? _c("div", { staticClass: "embed-responsive", class: [_vm.css] }, [
        _c("iframe", {
          staticClass: "embed-responsive-item",
          attrs: {
            sandbox:
              "allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation",
            allowfullscreen: "",
            src: _vm.url
          }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }